module.exports = __webpack_public_path__ + "static/media/jarvi.4ac7de05.png";